<template>
    <vue-cal :events="eventList"
             :disable-views="['years', 'year', 'day', 'week']"
             :time-from="17 * 60"
             :time-to="23 * 60"
             :time-step="30"
             :locale="calendar_locale"
             hide-view-selector
             active-view="month"
             :on-event-click="selectEvent"
             @cell-focus="selectDay"
             events-on-month-view="short">

        <template v-slot:event="{ event }">


            <div class="vuecal__event-title">
                <h5>{{event.title}}</h5>
                <b-icon-tag></b-icon-tag>{{event.available_seats}}
                <b-icon-circle-fill :class="event.classstore"></b-icon-circle-fill>
            </div>

            <small class="vuecal__event-time">
                <!-- Using Vue Cal injected Date prototypes -->
            </small>
        </template>

    </vue-cal>
</template>

<script>
    import moment from 'moment'
    moment.locale('IT');

    import VueCal from 'vue-cal'
    import 'vue-cal/dist/vuecal.css'
    import 'vue-cal/dist/i18n/it.js'
    import 'vue-cal/dist/i18n/es.js'
    import 'vue-cal/dist/i18n/de.js'
    import 'vue-cal/dist/i18n/fr.js'

    export default {
        name: "Calendar",
        props: ['locale', 'style_empty'],
        components: {
            VueCal
        },
        data () {
            return {
                selected_tour: null,
                tour_duration: 40,
                eventList: []
            }
        },
        computed: {
            calendar_locale() {
                return this.locale.toLowerCase();
            },
            tour_duration_in_sec() {
                return this.tour_duration * 60;
            }
        },
        methods: {
            addEventsFromSnapshot: function(_firestore_snapshot){
                this.eventList.length = 0;
                _firestore_snapshot.forEach(function (doc) {
                    this.addEventToCalendar(doc.data(), doc.id);
                }.bind(this));
            },
            addEventToCalendar: function(firebase_event, firebase_event_id){
                let starttime = new Date(firebase_event.start.seconds * 1000)

                let event = {
                    start : starttime,
                    end : new Date((firebase_event.end.seconds) * 1000),
                    title : new moment(starttime).format('HH:mm') + ' - ' + firebase_event.tour.Language,
                    //data: firebase_event.data,
                    available_seats: firebase_event.available_seats,
                    occupancy: firebase_event.occupancy,
                    tour: firebase_event.tour,
                    id: firebase_event_id
                }

                let seats = event.available_seats / event.occupancy;
                if (seats < 0.1) {
                    //event.class = 'notavail';
                    event.class = '';
                    event.classstore = 'notavail';
                } else if (seats <= 0.5) {
                    //event.class = 'halfway';
                    event.class = '';
                    event.classstore = 'halfway';
                } else if (seats > 0.5){
                    //event.class = 'avail';
                    event.class = '';
                    event.classstore = 'avail';
                }

                if (this.style_empty && event.available_seats === event.occupancy){
                    //event.class = 'empty';
                    event.classstore = 'empty';
                }

                this.eventList.push(event);
            },
            selectDay: function (day) {
                this.$emit('day-click', day)
            },
            selectEvent: function(event, e) {
                if(this.selected_tour && this.selected_tour !== event ){
                    //this.selected_tour.class = this.selected_tour.classstore;
                    this.selected_tour.class = '';
                }

                /*if(event.class === event.classstore){*/
                if(event.class === ''){
                    event.class = 'highlight';
                    this.selected_tour = event;
                    this.$emit('event-click', event);
                } else {
                    //event.class = event.classstore;
                    event.class = '';
                    this.selected_tour = null;
                    this.$emit('event-click', null);
                }
                e.stopPropagation();
            },
        }
    }
</script>

<style scoped>

    .vuecal {
        min-height: 600px;
        background-color: #fff;
    }

    /deep/ .vuecal__cell-content {
        justify-content: flex-start;
        padding-top: 5px;
        padding-left: 5px;
    }

    /*/deep/ .vuecal--week-view .vuecal__no-event {
        display: none;
    }*/

    /deep/ .month-view .vuecal__event {
        min-height:50px;
        margin: 5px;
        width:95%;
    }

    /deep/ .vuecal__event {
        border: 1px solid #a9a9a9;
        background-color: #f6f6f6;
        font-size:14px;
        font-weight:bold;
    }

    /deep/ .vuecal__event-time {
        font-size:12px;
        font-weight:lighter;
        font-style: italic;
    }

    /deep/ .notavail {
        /*background-color: red;
        border: 3px solid red;*/
        color: red;
    }

    /deep/ .avail {
        /*background-color: greenyellow;
        border: 3px solid #adff2f;*/
        color: #87e200
    }

    /deep/ .halfway {
        /*background-color: orange;
        border: 3px solid orange;*/
        color: orange;
    }

    /deep/ .highlight {
        border: 1px solid #ff6822;
        /*background-color: yellow !important;*/
    }

    @media screen and (max-width: 400px) {
        /deep/ .vuecal__cell {
            display: none;
        }

        /deep/ .vuecal__cell-date {
            font-size: 0.8em;
            position: absolute;
            text-align: left;
        }

        /deep/ .vuecal__cell--has-events{
            display: flex;
        }

        /deep/ .vuecal__cell--out-of-scope {
            display: none;
        }

        /*/deep/ .vuecal__cell-events {

        }*/

        /deep/ .vuecal__cells.month-view .vuecal__cell {
            width: 100%;
        }

        /deep/ .month-view .vuecal__event {
            min-height: 50px;
            /*margin: 0 auto;*/
            margin-left: 23px;
            width: 90%;
        }
    }

</style>
